import React from "react";
import { RotateLoader } from "react-spinners";
import { Box } from "@mui/material";

const Loader = ({ size = 20, marginTop = "30%", marginBottom = "30%" }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    marginTop={marginTop}
    marginBottom={marginBottom}
  >
    <RotateLoader color="#b10511" loading={true} size={size} />
  </Box>
);

export default Loader;